// The extension follows the LAST dot - a name like "Acer_1.0_x.zip" carries dots of its own.
export const getTruncatedFilename = (filename: string, length?: number) => {
  const len = length ?? 21;
  const dot = filename.lastIndexOf('.');
  const name = dot < 0 ? filename : filename.substring(0, dot);
  const extension = dot < 0 ? '' : filename.substring(dot + 1);

  if (name.length <= len)
    return filename;

  return extension ? `${name.substring(0, len)}....${extension}` : `${name.substring(0, len)}....`;
}
